<template>
	<nav class="navbar navbar-expand-lg navbar-dark bg-dark main-menu sticky-top">
		<a class="navbar-brand" href="/">
			<img src="../assets/common/logo-white.png" alt="Logo" class="logo" />
		</a>
		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#mainNavbarToggler" aria-controls="mainNavbarToggler" aria-expanded="false" aria-label="Toggle navigation">
			<i class="fas fa-bars"></i>
		</button>
		<div class="collapse navbar-collapse" id="mainNavbarToggler">
			<a v-bind:href="login_url" class="ml-auto" v-if="!__watcher_logged_in">
				<i class="fas fa-sign-in-alt mr-1"></i>
				<span v-html="Translate('@_UI_LOGIN')"></span>
			</a>
			<ul class="d-none d-lg-block navbar-nav ml-auto" v-if="__watcher_logged_in">
				<li class="nav-item dropdown">
					<a id="navbarDropdown" class="nav-link dropdown-toggle" href="javascript: void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span v-html="user.firstname + ' ' + user.lastname"></span>
						<span class="badge badge-info ml-1" v-html="user.notifications" v-if="!isNaN(user.notifications) && user.notifications > 0"></span>
					</a>
					<div class="dropdown-menu dropdown-menu-right mt-2" aria-labelledby="navbarDropdown">
						<div class="dropdown-item-text">
							<h6 class="mb-0"><span v-html="Translate('@_USER_TYPE')"></span>: <span v-html="Translate('@_USER_TYPE_' + user.kind)"></span></h6>
						</div>
						<div class="dropdown-divider" v-if="isAdmin"></div>
						<!-- <router-link class="dropdown-item" v-bind:to="{ name: 'prize' }" v-if="isAdmin">
							<span v-html="Translate('@_CANDIDATE_FOR_AWARD')"></span>
						</router-link> -->
						<router-link class="dropdown-item" v-bind:to="{ name: 'schedule' }" v-if="isAdmin">
							<span v-html="Translate('@_SCHEDULE')"></span>
						</router-link>
						<div class="dropdown-divider"></div>
						<router-link class="dropdown-item" v-bind:to="{ name: 'notifications' }">
							<span v-html="Translate('@_NOTIFICATIONS')"></span>
							<span class="badge badge-info ml-1" v-html="user.notifications" v-if="!isNaN(user.notifications) && user.notifications > 0"></span>
						</router-link>
						<router-link class="dropdown-item" v-bind:to="{ name: 'theses' }">
							<span v-html="Translate('@_GRADUATE_THESIS_LIST')"></span>
						</router-link>
						<div class="dropdown-divider"></div>
						<router-link class="dropdown-item" v-bind:to="{ name: 'profile' }">
							<span v-html="Translate('@_PROFILE')"></span>
						</router-link>
						<div class="dropdown-divider"></div>
						<router-link class="dropdown-item" v-bind:to="{ name: 'about' }">
							<span v-html="Translate('@_ABOUT')"></span>
						</router-link>
						<div class="dropdown-divider"></div>
						<a class="dropdown-item" href="javascript: void(0);" v-on:click="logout()">
							<span v-html="Translate('@_LOGOUT')"></span>
						</a>
					</div>
				</li>
			</ul>
			<div class="d-lg-none" v-if="__watcher_logged_in">
				<div class="text-white mt-2 mb-3">
					<span v-html="user.firstname + ' ' + user.lastname"></span>
				</div>
				<div class="card mt-2 py-1">
					<div class="dropdown-item-text">
						<h6 class="mb-0"><span v-html="Translate('@_USER_TYPE')"></span>: <span v-html="Translate('@_USER_TYPE_' + user.kind)"></span></h6>
					</div>
					<div class="dropdown-divider" v-if="isAdmin"></div>
					<!-- <router-link class="dropdown-item" v-bind:to="{ name: 'prize' }" v-if="isAdmin">
						<span v-html="Translate('@_CANDIDATE_FOR_AWARD')"></span>
					</router-link> -->
					<router-link class="dropdown-item" v-bind:to="{ name: 'schedule' }" v-if="isAdmin">
						<div v-html="Translate('@_SCHEDULE')" class="w-100" v-on:click="closeMobileMenu()"></div>
					</router-link>
					<div class="dropdown-divider"></div>
					<router-link class="dropdown-item" v-bind:to="{ name: 'notifications' }">
						<div class="w-100" v-on:click="closeMobileMenu()">
							<span v-html="Translate('@_NOTIFICATIONS')"></span>
							<span class="badge badge-info ml-1" v-html="notifications.unread"></span>
						</div>
					</router-link>
					<router-link class="dropdown-item" v-bind:to="{ name: 'theses' }">
						<div v-html="Translate('@_GRADUATE_THESIS_LIST')" class="w-100" v-on:click="closeMobileMenu()"></div>
					</router-link>
					<div class="dropdown-divider"></div>
					<router-link class="dropdown-item" v-bind:to="{ name: 'profile' }">
						<div v-html="Translate('@_PROFILE')" class="w-100" v-on:click="closeMobileMenu()"></div>
					</router-link>
					<div class="dropdown-divider"></div>
					<a class="dropdown-item" href="javascript: void(0);" v-on:click="logout()">
						<div v-html="Translate('@_LOGOUT')" class="w-100" v-on:click="closeMobileMenu()"></div>
					</a>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
import $ from "jquery";
import Mixin from "@/helpers/mixin";

export default {
	name: "MainMenu",
	mixins: [Mixin],
	data() {
		return {};
	},
	computed: {
		login_url() {
			return this.settings.url.login === null ? "#" : this.settings.url.login;
		}
	},
	methods: {
		closeMobileMenu() {
			$("#mainNavbarToggler").collapse("hide");
		},
		logout() {
			localStorage.removeItem("token");
			this.$router.go("/home").catch(err => {
				console.log(err);
			});
		}
	},
	watch: {
		login_url(newVal, oldVal) {
			console.log(newVal, oldVal);
		}
	},
	created() {}
};
</script>

<style scoped>
.navbar-brand .logo {
	max-height: 36px;
}
</style>
